import { Button } from '~/components/ui/Button';
import { useClaimProject } from '@shadcn/hooks/use-configure-project';

export function AdvancedSettings() {
  const { mutate: claimProject, isPending: isClaiming } = useClaimProject();

  return (
    <div className="p-6 pt-4 lg:p-8 lg:pt-8">
      <h2 className="text-base lg:text-xl font-semibold mb-6">Advanced Settings</h2>
      <div className="flex justify-between gap-4 items-center">
        <div className="flex flex-col gap-1">
          <label className="font-semibold text-sm text-bolt-ds-textPrimary">Claim in Supabase</label>
          <div className="text-sm text-bolt-ds-textSecondary">Move this database into your own Supabase account.</div>
        </div>
        <Button
          className="w-min"
          size="md"
          color="warning"
          variant="link-color"
          onClick={() => {
            claimProject();
          }}
          disabled={isClaiming}
          loading={isClaiming}
        >
          Claim
        </Button>
      </div>
    </div>
  );
}
